import React, { useState, useEffect } from 'react';
import {
  Table
} from 'reactstrap';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SelectRF from '../../../../../../../../components/UIComponents/Fields/SelectRF';
import InputField from '../../../../../../../../components/UIComponents/Fields/InputRF';
import {
  addFields,
  editFields,
  setActive,
  changeName,
  changeListSelection
} from '../../../../actions';
import usePagination from '../../../../../../../../utils/DataTable/usePagination';
import useFilter from '../../../../../../../../utils/DataTable/useFilter';
import Pagination from '../../../../../../../../components/UIComponents/Pagination';
import SearchInput from '../../../../../../../../components/UIComponents/Fields/SearchInput';

function Nodes({
  fields,
  unit,
  supportsList,
  changeName,
  changeListSelection
}) {
  const [filteredFields, setFilteredFields] = useState(fields);
  useEffect(() => {
    setFilteredFields(fields);
  }, [fields]);

  const onSearch = input => {
    setFilteredFields(useFilter(fields, input).matchedFields);
  }

  const {
    pageNumbers,
    currentTodos,
    paginatedFields,
    setPaginatedFields
  } = usePagination(filteredFields);

  const findIndex = (type) => {
    const squareBracketsRegex = /\[(.*?)\]/;
    const matchField = type.match(squareBracketsRegex)[0];
    const index = matchField.replace(/^\[(.+)\]$/, '$1');
    return parseInt(index);
  };

  return (
    <div>
      <div>
        <SearchInput onSearch={onSearch} />
      </div>
      <Table responsive>
        <thead>
          <tr className="column">
            <th>name</th>
            <th>support</th>
            <th>{`X(${unit.text})`}</th>
            <th>{`Y(${unit.text})`}</th>
            <th>{`Z(${unit.text})`}</th>
            <th />
            <th />
          </tr>
        </thead>
        <tbody>
          {currentTodos.map((type, index) => (
            <tr key={index}>
              <td className="tableTd">
                <InputField
                  name={`${type}.name`}
                  type="text"
                  onChange={(e) => {
                    const val = e.target.value;
                    changeName('nodes', findIndex(type), val);
                    const nodeList = fields.getAll();
                    changeListSelection('members', 'nodei', nodeList, index, val);
                    changeListSelection('members', 'nodej', nodeList, index, val);
                    changeListSelection('nodeLoads', 'node', nodeList, index, val);
                  }}
                />
              </td>
              <td className="tableTd">
                <SelectRF
                  name={`${type}.support`}
                  list={supportsList}
                />
              </td>
              <td className="tableTd">
                <InputField name={`${type}.X`} type="text" />
              </td>
              <td className="tableTd">
                <InputField name={`${type}.Y`} />
              </td>
              <td className="tableTd">
                <InputField name={`${type}.Z`} />
              </td>
              <td className="tableTd">
                <i
                  className="material-icons"
                  onClick={() => {
                    const val = Math.floor(Math.random() * 10000);
                    const itemIndex = findIndex(type);
                    fields.insert(itemIndex + 1, {
                      name: `Node${val}`,
                      label: `Node${val}`,
                      value: `Node${val}`,
                      support: supportsList[0].name,
                      X: 0,
                      Y: 0,
                      Z: 0
                    }
                    )
                  }}
                >
                  {'add_circle'}
                </i>
              </td>
              <td className="tableTd">
                {
                  fields.length > 1 &&
                  <i
                    className="material-icons"
                    onClick={() => {
                      const itemIndex = findIndex(type);
                      fields.remove(itemIndex)
                    }}
                  >
                    {'remove_circle'}
                  </i>
                }
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination
        pageNumbers={pageNumbers}
        currentTodos={currentTodos}
        paginatedFields={paginatedFields}
        setPaginatedFields={setPaginatedFields}
      />
    </div>
  )
};


const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    addFields,
    editFields,
    setActive,
    changeName,
    changeListSelection
  }, dispatch);
};

export default compose(
  connect(null, mapDispatchToProps),
)(Nodes);
